let isAwaitingRegistrationSuccessRedirect = false;

function setAwaitingRegistrationSuccessRedirect(isAwaiting: boolean): void {
  isAwaitingRegistrationSuccessRedirect = isAwaiting;
}

function getAwaitingRegistrationSuccessRedirect(): boolean {
  return isAwaitingRegistrationSuccessRedirect;
}

export { getAwaitingRegistrationSuccessRedirect, setAwaitingRegistrationSuccessRedirect };
